// Store singleton per accedere al config fuori da React (es. moduli API).
// Viene popolato da ConfigProvider subito dopo il caricamento.
let _config = null;

export function setConfig(cfg) {
  _config = cfg;
}

export function getConfig() {
  return _config;
}


